/**
 * formdata => query
 * @param obj
 * @returns {string}
 */
export const formatQuery = (obj = {}) => {
  let query = '?'
  Object.keys(sortObj(obj)).forEach(key => {
    query += `${key}=${encodeURIComponent(obj[key])}&`
  })
  return query.substring(0, query.length - 1)
}

/**
 * 对象去重排序
 * @param obj
 * @returns {Object}
 */
export const sortObj = obj => {
  const _obj = {}
  Array.from(new Set(Object.keys(obj))).sort().map(key => {
    _obj[key] = obj[key]
  })
  return _obj
}